/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReferredUserData,
    ReferredUserDataFromJSON,
    ReferredUserDataFromJSONTyped,
    ReferredUserDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferredUsersResponse
 */
export interface ReferredUsersResponse {
    /**
     * 
     * @type {Array<ReferredUserData>}
     * @memberof ReferredUsersResponse
     */
    referredUsersData: Array<ReferredUserData>;
}

export function ReferredUsersResponseFromJSON(json: any): ReferredUsersResponse {
    return ReferredUsersResponseFromJSONTyped(json, false);
}

export function ReferredUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'referredUsersData': ((json['referredUsersData'] as Array<any>).map(ReferredUserDataFromJSON)),
    };
}

export function ReferredUsersResponseToJSON(value?: ReferredUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'referredUsersData': ((value.referredUsersData as Array<any>).map(ReferredUserDataToJSON)),
    };
}


